import { getHostUrl } from '@/ViteDynamicContentLoader';
export function getUrl(url = '/api/ens/v1/') {
  if (getHostUrl()) {
    url = getHostUrl() + url;
  }
  return url;
}
